<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="disableSaving" title=Guardar type="button" class="btn btn-outline-success" (click)="onGuardarInspecciones()"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
            <button [disabled]="disableRevision" type="button" title="Revisión Solicitante" class="btn btn-outline-success" (click)="onRevisionSolicitanteConfirm()"><i class="fa fa-reply"></i> Revisión Solicitante</button>
            <button [disabled]="!habilitarNuevoSeguimiento" class="btn btn-outline-success" type="button" (click)="onAdd()"><i class="icon-seguimiento"></i> Nuevo Seguimiento</button>
            <button *ngIf="visibilityBtnRechazoParcial" type="button" title="Presentar Rechazo Parcial" class="btn btn-outline-success button-border-restore" (click)="onPresentarRechazoParcial()"><i class="fa fa-ban"></i> Presentar Rechazo Parcial</button>
        </div>
    </nav>

    <!--<app-destinocontrolpopup></app-destinocontrolpopup>-->
    <app-organismosnocivospopup (selectedEmitter)="onAceptDialogOrganismoNocivo($event)"></app-organismosnocivospopup>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Inspecciones {{CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitud | IconoTipoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
                <img *ngIf="IdEstadoChedPp" class="estado-icono-big" container="body" src="{{IdEstadoChedPp | IconoEstadoChedPP}}" ngbTooltip="{{IdEstadoChedPpDescripcion}}" />
                <img *ngIf="IdResultadoEnvioMuestrasLaboratorio" class="estado-icono-big" container="body" src="{{IdResultadoEnvioMuestrasLaboratorio | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{DescripcionIdResultadoEnvioMuestrasLaboratorio}}" />
                <img class="predua-icono-big" container="body" ngbTooltip="{{EsPredua | preduaNoPredua}}" src="{{EsPredua | IconoPreduaSolicitud}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div *ngIf="visibilitySpinner" class="nota-info warning mb-2">
            <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Por favor, no salga de la ventana actual, hay una operación en curso.</label>
        </div>

        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="IdSolicitud">
                    <app-alerta-chedd [solicitud]="solicitud"></app-alerta-chedd>
                    <app-alertarechazo [id]="IdSolicitud" [esImport]="true"></app-alertarechazo>
                </ng-container>

                <div class="row">

                    <div class="col-md-3">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-list"></i> <strong>Equipamiento</strong>
                            </div>
                            <div class="card-body-grid">
                                <!--GRID-->
                                <div class="row">
                                    <!--NO ES PREDUA-->
                                    <div class="col-md-12">

                                        <label class="cabeceraTablaDetalles">Matrículas / Nº Contenedor</label>
                                        <table class="table table-list table-sm">
                                            <tbody>
                                                <tr formArrayName="matriculasInsp" *ngFor="let order of getMatriculaControls(); let i = index">
                                                    <td><p-checkbox [formControlName]="i" binary="true"></p-checkbox></td>
                                                    <td>{{matriculasInsp[i].Matricula}}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div>
                                            <input *ngIf="false" formControlName="validPosicionamiento" [ngClass]="displayFieldCss('validPosicionamiento')" name="" title="" class="form-control" id="inpDescripcion" value="">
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('validPosicionamiento','required')">
                                                Debe marcar al menos un posicionamiento
                                            </div>
                                        </div>
                                    </div>

                                    <!--RDLF: 23/10/24 de momento los preduas cargan los equipamientos igual que los no preduas (144302)-->
                                    <!--ES PREDUA-->
                                    <!--<div *ngIf="EsPredua" class="col-md-12">
                                        <label class="cabeceraTablaDetalles">Matrículas / Nº Contenedor</label>
                                        <table class="table table-responsive table-sm scroll">
                                            <tbody>
                                                <tr *ngFor="let item of posicionamientopredua">
                                                    <td>{{item.Matricula}}</td>
                                                    <td>{{item.FechaAutorizacion | date:'dd/MM/yyyy'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-9" *ngIf="mostrarFrecuenciaReducida">
                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> <strong>Frecuencia Reducida - Sanidad Vegetal</strong>
                            </div>

                            <div class="card-body-grid">

                                <p-table #tableSearch autoLayout="true" [value]="frInsp"
                                         [columns]="colsFrecRed" sortField="GrupoFrDescripcion" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(frInsp)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>
                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='Frecuencia' && col.field!=='PorcentajePif' && col.field!=='PorcentajeNacional')">
                                                    {{ rowData[col.field] }}
                                                </span>

                                                <span *ngIf="col.field === 'Frecuencia'" [ngClass]="'cumplefr'">
                                                    {{ rowData[col.field] }} %
                                                </span>

                                                <span *ngIf="col.field === 'PorcentajePif'"
                                                      [ngClass]="rowData[col.field] < rowData['Frecuencia'] ? 'nocumplefr' : 'cumplefr'"
                                                      ngbTooltip="{{ rowData['TotalConFisicaPif'] }} de {{ rowData['TotalPif'] }}">

                                                    {{ rowData[col.field] }} %
                                                </span>

                                                <span *ngIf="col.field === 'PorcentajeNacional'" [ngClass]="rowData[col.field] < rowData['Frecuencia'] ? 'nocumplefr' : 'cumplefr'"
                                                      ngbTooltip="{{ rowData['TotalConFisicaNacional'] }} de {{ rowData['TotalNacional'] }}">
                                                    {{ rowData[col.field] }} %
                                                </span>

                                                <div *ngIf="col.field==='Link'" class="btn-group">                                                     

                                                    <div *ngIf="esRechazoParcial">
                                                        <!--ICONO rechazo parcial-->
                                                        <img class="icono-info-grid" src="{{null | IconoProdsEmbsRp}}" container="body"/>
                                                    </div>

                                                    <div *ngIf="esRechazoParcial">
                                                        <div *ngIf="rowData['Aceptado'] === true"><img class="icono-info-grid-small" src="{{rowData['Aceptado'] | IconoProdsEmbsRpAceptado}}" container="body" /></div>
                                                        <div *ngIf="rowData['Aceptado'] === false"><img class="icono-info-grid-small" src="{{rowData['Aceptado'] | IconoProdsEmbsRpAceptado}}" container="body" /></div>
                                                    </div>                                                

                                                </div>

                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="mostrarFrSanidadExt">
                        <app-fr-sanidad-ext [frSanidadExtInsp]="frSanidadExtInsp" [esRechazoParcial]="esRechazoParcial"></app-fr-sanidad-ext>
                    </ng-container>
                </div>

                <!--RESOLUCIÓN-->
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> <strong>Resolución</strong>
                        </div>
                    </a>
                    <div class="card-body-detalle">

                        <div class="row">
                            <div class="form-group col-md-3 pt-4">
                                <label class="col-form-label pe-4" for="inpPreDua">Documental: </label>
                                <p-triStateCheckbox formControlName="Documental" label="{{labelDocumental}}" [ngClass]="displayFieldCss('Documental')" (onChange)="onChangeDocumental()"></p-triStateCheckbox>

                            </div>
                            <div class="form-group col-md-6">
                                <label class="col-form-label" for="inpCodigo">Inspector Documental</label>
                                <input readonly formControlName="InspectorDocumental" name="InspectorDocumental" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                            </div>
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFecha">Fecha Documental</label>
                                <input formControlName="FechaDocumental" name="FechaDocumental" readonly title="" class="form-control" id="inpDescripcion" value="">
                            </div>
                        </div>

                        <fieldset class="mt-2 card">

                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label class="col-form-label">Se efectúa Inspección Identidad y/o Física </label>
                                    <p-toggleButton class="form-control-togglebutton"
                                                    formControlName="SeEfectuaIdentidadFisica" onLabel="Sí" offLabel="NO"
                                                    onIcon="pi pi-check" offIcon="pi pi-times" (onChange)="onSelectedIdentidadFisica()" id=""></p-toggleButton>
                                </div>
                                <div class="form-group col-md-9" *ngIf="mostrarMensajePredua">
                                    <label class="col-form-label label-msg-info">
                                        <span>Por ser una solicitud PreDua la inspección hay que realizarla en dos pasos. <br /></span>
                                        <span>Guarde para continuar la inspección de Identidad y Física.</span>
                                    </label>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-3 pt-4">
                                    <label class="col-form-label col-3">Identidad: </label>
                                    <p-triStateCheckbox formControlName="Identidad" label="{{labelIdentidad}}" (onChange)="onChangeIdentidad()"></p-triStateCheckbox>
                                </div>
                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="inpCodigo">Inspector Identidad</label>
                                    <input readonly formControlName="InspectorIdentidad" name="InspectorIdentidad" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Identidad</label>
                                    <input formControlName="FechaIdentidad" name="FechaIdentidad" readonly title="" class="form-control" id="inpDescripcion" value="">
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-md-3 pt-4">
                                    <label class="col-form-label pe-3 col-3">Física: </label>
                                    <p-triStateCheckbox formControlName="Fisica" label="{{labelFisica}}" (onChange)="onChangeFisica()"></p-triStateCheckbox>
                                </div>
                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="inpCodigo">Inspector Física</label>
                                    <input readonly formControlName="InspectorFisica" name="InspectorFisica" title="" class="form-control" id="inpDescripcion" type="text" value="" maxlength="50">
                                </div>
                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpFecha">Fecha Física</label>
                                    <input formControlName="FechaFisica" name="FechaFisica" readonly title="" class="form-control" id="inpDescripcion" value="">
                                </div>

                            </div>
                        </fieldset>

                        <!--SEGUIMIENTOS INSPECCIÓN-->
                        <div *ngIf="TComentarioInspectorCollection != null && TComentarioInspectorCollection.length > 0" class="card card-accent-success">

                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> Listado de Seguimientos de Inspección

                            </div>

                            <div class="card-body-grid">

                                <p-table #tableSearchObservaciones autoLayout="true" [value]="TComentarioInspectorCollection"
                                         [columns]="colsObservaciones" sortField="Fecha" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm"
                                         [ngClass]="displayGridHidden(TComentarioInspectorCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='Fecha')">{{rowData[col.field]}}</span>
                                                <span *ngIf="col.field==='Fecha'">{{rowData[col.field] | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                                                <div *ngIf="col.field==='Link'" class="btn-group">
                                                    <div *ngIf="checkEdit(rowData)">
                                                        <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                                class="btn btn-sm btn-warning">
                                                            <span class="fa fa-edit"></span>

                                                        </button>
                                                    </div>

                                                    <div *ngIf="!checkEdit(rowData)">
                                                        <button (click)="onEdit(rowData)" type="button" title="Consultar"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-search"></span>

                                                        </button>
                                                    </div>

                                                    <div *ngIf="checkDelete(rowData)">
                                                        <button (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                                class="btn btn-sm btn-danger">
                                                            <span class="fa fa-remove"></span>

                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                                <div *ngIf="TComentarioInspectorCollection?.length == 0" class="empty-grid">
                                    No hay seguimientos asociados a la solicitud
                                </div>
                            </div>
                        </div>

                        <!--OBSERVACIONES INSPECCIÓN-->
                        <div class="row group-filtros">
                            <div class="form-group col-md-12">
                                <label class="col-form-label" [ngClass]="{ 'required-field' : requerirObservaciones}" for="inpCodigo">Observaciones Resultado Inspección</label>
                                <textarea style="resize:none" formControlName="Observaciones"
                                          maxlength="5000" name="Observaciones" title="" type="text" class="form-control" inputStyleClass="form-control"
                                          value=""></textarea>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Observaciones','required')">
                                    Observaciones es obligatorio
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--DECISIÓN-->                
                    <div class="card card-accent-success animated fadeIn" *ngIf="visibilityDecision" >
                        <a class="card-header-a">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> <strong>Decisión</strong>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="group-campos" id="">
                                <div class="row" style="flex-wrap: nowrap">

                                    <div *ngIf="habilitarAceptarDecision" class="col-md-4" style="text-align:center">
                                        <p-radioButton class="radiobuttonSuccess" formControlName="IdDecision" (click)="onSelectedDecision()"
                                                       inputStyleClass="form-control" name="IdDecision" value="{{ enumDecisionLetter.ACEPTAR }}" label="{{ labelAceptar }}"></p-radioButton>
                                    </div>
                                    <div *ngIf="habilitarRechazarDecision" class="col-md-4" style="text-align:center">
                                        <p-radioButton class="radiobuttonDanger" formControlName="IdDecision" (click)="onSelectedDecision()" inputStyleClass="form-control" name="IdDecision"
                                                       value="{{ enumDecisionLetter.RECHAZAR }}" label="Rechazar"></p-radioButton>
                                    </div>
                                    <div *ngIf="canNoAptoPorHigiene" class="col-md-4" style="text-align:center">
                                        <p-radioButton class="radiobuttonDanger" formControlName="IdDecision" (click)="onSelectedDecision()" inputStyleClass="form-control" name="IdDecision"
                                                       value="{{ enumDecisionLetter.NO_APTO_POR_HIGIENE }}" label="{{ DESCRIPCION_NO_APTO_POR_HIGIENE }}"></p-radioButton>
                                    </div>
                                    <div *ngIf="canRechazoParcial" class="col-md-4" style="text-align:center">
                                        <p-radioButton class="radiobuttonWarning" formControlName="IdDecision" (click)="onSelectedDecision()" inputStyleClass="form-control" name="IdDecision"
                                                       value="{{ enumDecisionLetter.RECHAZAR_PARCIALMENTE }}" label="Rechazar Parcialmente"></p-radioButton>
                                    </div>
                                    <div *ngIf="visibilityNoProcede" class="col-md-4" style="text-align:center">
                                        <p-radioButton class="radiobuttonInfo" formControlName="IdDecision" (click)="onSelectedDecision()" inputStyleClass="form-control" name="IdDecision"
                                                       value="{{ enumDecisionLetter.NO_PROCEDE }}" label="{{labelNoProcede}}"></p-radioButton>
                                    </div>

                                </div>

                                <!--MENSAJE NO PROCEDE-->
                                <div class="row">
                                    <div *ngIf="visibilityMensajeNoProcede" class="col-md-12">                                        
                                        <h6 class="pt-3">* No procede la emisión del Ched PP</h6>
                                    </div>
                                </div>
                                <!--MENSAJE RECHAZO PARCIAL-->
                                <div class="row">
                                    <div *ngIf="visibilityMsgRechazoParcial" class="col-md-12">                                        
                                        <h6 class="pt-3">Al realizar un rechazo parcial podrá seleccionar los productos y/o embalajes para dividir la solicitud en dos nuevos expedientes, para cada una de las nuevas solicitudes tendrá que tomar la decisión correspondiente.</h6>
                                    </div>
                                </div>
                                <!--MENSAJE RE-IMPORTACIÓN-->
                                <div class="row">
                                    <div *ngIf="EsReImportacion" class="col-md-12">                                        
                                        <h6 class="pt-3">Para ACEPTAR las Re-Importaciones es necesario efectuar la inspección de Identidad</h6>
                                    </div>
                                </div>

                                <!--FECHA FINALIZACION-->
                                <div class="row">
                                    <div *ngIf="fechaFinalizacion !== null" class="col-md-12">
                                        <hr />
                                        <h6>Fecha de la Decisión: {{fechaFinalizacion}}</h6>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>                

                    <!--TIPO INSPECCIÓN DEL RECHAZO-->
                    <div *ngIf="visibilityMedidasRechazos">

                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a">
                                <div class="card-header-buscador">
                                    <i class="fa fa-list"></i> <label class="required-field"><strong>Tipo de inspección</strong></label>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="group-campos" id="">
                                    <div class="row">
                                        <div class="form-group col-md-12 form-inline" style="margin-top:5px">
                                            <p-checkbox formControlName="TipoInspSupervisionPuestoInsp" binary="true"></p-checkbox>
                                            <label class="col-form-label" style="margin-left:0.75%">Supervisión del ingreso al puesto de inspección</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-12 form-inline">
                                            <p-checkbox formControlName="TipoInspControlSeguimientoNoSintomas" binary="true"></p-checkbox>
                                            <label class="col-form-label" style="margin-left:0.75%">Control de seguimiento realizado del envío sin síntomas ni sospechas y sin retención del envío</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-12 form-inline">
                                            <p-checkbox formControlName="TipoInspControlSeguimientoSiSintomas" binary="true"></p-checkbox>
                                            <label class="col-form-label" style="margin-left:0.75%">Control de seguimiento realizado del envío con síntomas o sospechas</label>
                                        </div>
                                    </div>

                                </div>
                                <div class="row group-filtros">
                                    <input *ngIf="false" formControlName="validTipoInspeccionRechazo" [ngClass]="displayFieldCss('validTipoInspeccionRechazo')" name="" title="" class="form-control" id="inpDescripcion" value="">
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('validTipoInspeccionRechazo','required')">
                                        Debe seleccionar al menos un Tipo de inspección
                                    </div>
                                </div>
                            </div>                            
                        </div>

                    </div>

                    <!-- * * *    M  O  T  I  V  O  S     Y     M  E  D  I  D  A  S     R  E  C  H  A  Z  O    * * * -->

                    <div *ngIf="visibilityMedidasRechazos">

                        <!-- M O T I V O S -->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a">
                                <div class="card-header-buscador">
                                    <i class="fa fa-list"></i> <label class="required-field"><strong>Motivos del Rechazo</strong></label>
                                </div>
                            </a>

                            <div class="card-body-detalle">

                                <div class="row" *ngIf="habilitarEdicion">

                                    <div class="form-group col-md-2">
                                        <label class="col-form-label required-field">Motivo</label>
                                        <ng-select [(items)]="listMotivosRechazo"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdMotivoRechazo"
                                                   loadingText="Cargando..."
                                                   [loading]="!listMotivosRechazo"
                                                   notFoundText="Motivo no encontrado"
                                                   placeholder="-- Seleccione un Motivo --"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectMotivoRechazo()">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                            </ng-template>
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdMotivoRechazo','required')">
                                            Motivo es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-5">
                                        <label class="col-form-label required-field">Detalle del Motivo</label>
                                        <ng-select [(items)]="listDetallesMotivoRechazo"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdDetalleMotivoRechazo"
                                                   loadingText="Cargando..."
                                                   [loading]="!listDetallesMotivoRechazo && form.value.IdMotivoRechazo !== null"
                                                   notFoundText="Detalle no encontrado"
                                                   placeholder="-- Seleccione un Detalle --"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectDetalleMotivoRechazo()">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                            </ng-template>
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdDetalleMotivoRechazo','required')">
                                            Detalle motivo es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-5">
                                        <label class="col-form-label required-field">Elemento</label>
                                        <div class="input-group">

                                            <ng-select [(items)]="listElementosRechazo"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdElementoRechazo"
                                                       loadingText="Cargando..."
                                                       [loading]="!listElementosRechazo"
                                                       notFoundText="Elemento no encontrado"
                                                       placeholder="-- Seleccione un Elemento --"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdElementoRechazo','required')">
                                                Elemento es obligatorio
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" *ngIf="habilitarEdicion">

                                    <div class="form-group col-md-7">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : requerirProductoMotivo}">Productos</label>
                                        <ng-select [(items)]="listProductosSolicitud"
                                                   [multiple]="true"
                                                   bindValue="Id"
                                                   bindLabel="IdTaricProductoNombreComun"
                                                   formControlName="IdProductoMotivoRechazo"
                                                   loadingText="Cargando..."
                                                   [loading]="!listProductosSolicitud"
                                                   notFoundText="Producto no encontrado"
                                                   placeholder="-- Seleccione un Producto --"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectProductoMotivoRechazo($event)">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.IdTaricProductoNombreComun}}">{{item.IdTaricProductoNombreComun}}</div>
                                            </ng-template>
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProductoMotivoRechazo','required')">
                                            Producto es obligatorio
                                        </div>

                                    </div>

                                    <div class="form-group col-md-5">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : requerirEmbalajeMotivo}">Embalajes</label>
                                        <ng-select [(items)]="listEmbalajesSolicitud"
                                                   [multiple]="true"
                                                   bindLabel="IdTaricEmbalajeDescripcion"
                                                   bindValue="Id"
                                                   formControlName="IdEmbalajeMotivoRechazo"
                                                   loadingText="Cargando..."
                                                   [loading]="!listEmbalajesSolicitud"
                                                   notFoundText="Embalaje no encontrado"
                                                   placeholder="-- Seleccione un Embalaje --"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectEmbalajeMotivoRechazo($event)">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.IdTaricEmbalajeDescripcion}}">{{item.IdTaricEmbalajeDescripcion}}</div>
                                            </ng-template>
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdEmbalajeMotivoRechazo','required')">
                                            Embalaje es obligatorio
                                        </div>

                                    </div>
                                </div>

                                <div class="row" *ngIf="habilitarEdicion && visualizarCamposDeOrganismosNocivos">

                                    <div class="form-group col-md-7">
                                        <label class="col-form-label required-field" for="">Organismo Nocivo</label>
                                        <div class="input-group">
                                            <input formControlName="OrganismoNocivo" name="OrganismoNocivo" [readonly]='true' title="" class="form-control" id="" type="text" value="" maxlength="100">
                                            <span class="input-group-btn">
                                                &nbsp;<button name="btnSearchOrganismoNocivo" class="btn btn-list btn-secondary" type="button" title="Buscar Organismo Nocivo" (click)="onSearchOrganismoNocivo()"><i class="fa fa-search"></i></button>
                                            </span>
                                        </div>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('OrganismoNocivo','required')">
                                            Organismo Nocivo es obligatorio
                                        </div>

                                    </div>

                                    <div class="form-group col-md-5">
                                        <label class="col-form-label required-field">Grado de contaminación</label>
                                        <div class="input-group">

                                            <ng-select [(items)]="listGradoContaminacion"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdGradoContaminacion"
                                                       loadingText="Cargando..."
                                                       [loading]="!listGradoContaminacion"
                                                       notFoundText="Grado de contaminación no encontrado"
                                                       placeholder="-- Seleccione un Grado de contaminación --"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdGradoContaminacion','required')">
                                                Grado contaminación es obligatorio
                                            </div>

                                        </div>
                                    </div>

                                </div>

                                <div class="row">

                                    <div class="form-group col-md-7" *ngIf="habilitarEdicion && esOrganismoNocivo_No_ReguladoUE">
                                        <label class="col-form-label required-field">Organismo Nocivo No Regulado por la UE</label>
                                        <div class="input-group">

                                            <ng-select [(items)]="listOrganismoNocivoNoReguladoUE"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdOrganismoNocivoNoReguladoUE"
                                                       loadingText="Cargando..."
                                                       [loading]="!listOrganismoNocivoNoReguladoUE"
                                                       notFoundText="Selección no encontrada"
                                                       placeholder="-- Seleccione una opción --"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdOrganismoNocivoNoReguladoUE','required')">
                                                Organismo Nocivo No Regulado por la UE es obligatorio
                                            </div>

                                        </div>

                                    </div>

                                    <div class="form-group col-md-5" *ngIf="habilitarEdicion && esOrganismoNocivo_No_Especie">
                                        <label class="col-form-label required-field">Organismo Nocivo No Especie</label>
                                        <div class="input-group">

                                            <ng-select [(items)]="listOrganismoNocivoNoEspecie"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdOrganismoNocivoNoEspecie"
                                                       loadingText="Cargando..."
                                                       [loading]="!listOrganismoNocivoNoEspecie"
                                                       notFoundText="Selección no encontrada"
                                                       placeholder="-- Seleccione una opción --"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdOrganismoNocivoNoEspecie','required')">
                                                Organismo Nocivo No Especie es obligatorio
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" *ngIf="habilitarEdicion">

                                    <!--OBSERVACIONES MOTIVOS-->
                                    <div class="form-group col-md-12">

                                        <label class="col-form-label" for="inpCodigo">Observaciones</label>
                                        <textarea style="resize:none" formControlName="ObservacionesMotivosRechazo"
                                                  maxlength="5000" name="ObservacionesMotivosRechazo" title="" type="text" class="form-control" inputStyleClass="form-control" rows="1"
                                                  value=""></textarea>
                                    </div>
                                </div>

                                <div class="row" *ngIf="habilitarEdicion">
                                    <div class="pt-2">
                                        <button [disabled]="!habilitarEdicion" name="btnAddMotivoRechazo" class="btn btn-list btn-secondary" style="text-align:center"
                                                type="button" title="Añade un Motivo" (click)="onAddMotivoRechazo()">
                                            <i class="fa fa-plus"></i> Añadir motivo
                                        </button>
                                    </div>
                                </div>

                                <!--GRID DATOS MOTIVOS-->
                                <p-table #tableSearch autoLayout="true" [value]="inspeccion.TSolicitudMotivoRechazoCollection"
                                         [columns]="colsMotivos" sortField="Id" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm pt-4"
                                         [ngClass]="displayGridHidden(inspeccion.TSolicitudMotivoRechazoCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='Id')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <div *ngIf="col.field==='Link'" class="btn-group">
                                                    <div>
                                                        <button [disabled]="!habilitarEdicion" (click)="onDeleteMotivoRechazo(rowData)" type="button" title="Eliminar"
                                                                class="btn btn-sm btn-danger">
                                                            <span class="fa fa-remove"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>

                                <div class="row group-filtros">
                                    <input *ngIf="false" formControlName="validMotivos" [ngClass]="displayFieldCss('validMotivos')" name="" title="" class="form-control" id="inpDescripcion" value="">
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('validMotivos','required')">
                                        Debe introducir al menos un Motivo
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- M E D I D A S -->
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a">
                                <div class="card-header-buscador">
                                    <i class="fa fa-list"></i> <label class="required-field"><strong>Medidas y Fecha</strong></label>
                                </div>
                            </a>

                            <div class="card-body-detalle">

                                <div class="row">
                                    <div class="form-group col-md-2">
                                        <label class="col-form-label">Fecha / Hora </label>
                                        <p-calendar formControlName="FechaMedidasRechazo" inputStyleClass="form-control"
                                                    showTime="true" [showIcon]="true" hourFormat="24" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                    </div>

                                    <!--OBSERVACIONES MEDIDAS-->
                                    <div class="form-group col-md-10">

                                        <label class="col-form-label" for="inpCodigo">Observaciones</label>
                                        <textarea style="resize:none" formControlName="ObservacionesMedidasRechazo" [ngClass]="displayFieldCss('ObservacionesMedidasRechazo')"
                                                  maxlength="5000" name="ObservacionesMedidasRechazo" title="" type="text" class="form-control" inputStyleClass="form-control" rows="1"
                                                  value=""></textarea>
                                    </div>
                                </div>

                                <hr />

                                <div class="row" *ngIf="habilitarEdicion">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label required-field">Medida</label>
                                        <ng-select [(items)]="listMedidasRechazo"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdMedidaRechazo"
                                                   loadingText="Cargando..."
                                                   [loading]="!listMedidasRechazo"
                                                   notFoundText="Medida no encontrada"
                                                   placeholder="-- Seleccione una Medida --"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectMedidaRechazo()">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                            </ng-template>
                                        </ng-select>

                                    </div>

                                    <div class="form-group col-md-6">

                                        <label class="col-form-label required-field">Alcance</label>
                                        <div class="input-group">

                                            <ng-select [(items)]="listAlcancesRechazo"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdAlcanceRechazo"
                                                       loadingText="Cargando..."
                                                       [loading]="!listAlcancesRechazo && form.value.IdMedidaRechazo !== null"
                                                       notFoundText="Alcance no encontrado"
                                                       placeholder="-- Seleccione un Alcance --"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                        </div>

                                    </div>
                                </div>

                                <div class="row" *ngIf="habilitarEdicion">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : requerirProductoMedida}">Productos</label>
                                        <ng-select [(items)]="listProductosSolicitud"
                                                   [multiple]="true"
                                                   bindValue="Id"
                                                   bindLabel="IdTaricProductoNombreComun"
                                                   formControlName="IdProductoMedidaRechazo"
                                                   loadingText="Cargando..."
                                                   [loading]="!listProductosSolicitud"
                                                   notFoundText="Producto no encontrado"
                                                   placeholder="-- Seleccione un Producto --"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectProductoMedidaRechazo($event)">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.IdTaricProductoNombreComun}}">{{item.IdTaricProductoNombreComun}}</div>
                                            </ng-template>
                                        </ng-select>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : requerirEmbalajeMedida}">Embalajes</label>
                                        <ng-select [(items)]="listEmbalajesSolicitud"
                                                   [multiple]="true"
                                                   bindLabel="IdTaricEmbalajeDescripcion"
                                                   bindValue="Id"
                                                   formControlName="IdEmbalajeMedidaRechazo"
                                                   loadingText="Cargando..."
                                                   [loading]="!listEmbalajesSolicitud"
                                                   notFoundText="Embalaje no encontrado"
                                                   placeholder="-- Seleccione un Embalaje --"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectEmbalajeMedidaRechazo($event)">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{item.IdTaricEmbalajeDescripcion}}">{{item.IdTaricEmbalajeDescripcion}}</div>
                                            </ng-template>
                                        </ng-select>
                                    </div>
                                </div>

                                <fieldset class="mt-3 mb-3 card" *ngIf="habilitarEdicion && esMedidaCuarentena">
                                    <strong>Cuarentena</strong>
                                    <br />
                                    <div class="row">
                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field">Fecha comienzo</label>
                                            <p-calendar formControlName="FechaComienzoCuarentena" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaComienzoCuarentena','required')">
                                                Fecha Comienzo Cuarentena es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field">Fecha terminación prevista</label>
                                            <p-calendar formControlName="FechaTerminacionPrevistaCuarentena" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaTerminacionPrevistaCuarentena','required')">
                                                Fecha Terminación Prevista Cuarentena es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field">Fecha terminación</label>
                                            <p-calendar formControlName="FechaTerminacionCuarentena" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaTerminacionCuarentena','required')">
                                                Fecha Terminación Cuarentena es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="intEstado">País de Cuarentena</label>
                                            <ng-select [items]="listPaisCuarentena"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdPaisCuarentena"
                                                       loadingText="Cargando..."
                                                       [loading]="!listPaisCuarentena"
                                                       notFoundText="País no encontrado"
                                                       placeholder="-- Seleccione un País --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelect('IdPaisCuarentena')">

                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                                </ng-template>
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisCuarentena','required')">
                                                País de Cuarentena es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inpTexto">Lugar de Cuarentena</label>
                                            <input formControlName="LugarCuarentena" name="LugarCuarentena" title="" class="form-control" inputStyleClass="form-control"
                                                   [ngClass]="displayFieldCss('LugarCuarentena')" id="inpLugarCuarentena" type="text" value="" maxlength="150">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('LugarCuarentena','required')">
                                                Lugar de Cuarentena es obligatorio
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <div class="row" *ngIf="habilitarEdicion">
                                    <div class="pt-2">
                                        <button [disabled]="!habilitarEdicion" name="btnAddMedidaRechazo" class="btn btn-list btn-secondary" style="text-align:center"
                                                type="button" title="Añade una Medida" (click)="onAddMedidaRechazo()">
                                            <i class="fa fa-plus"></i> Añadir medida
                                        </button>
                                    </div>
                                </div>

                                <!--GRID DATOS MEDIDAS-->
                                <p-table #tableSearch autoLayout="true" [value]="inspeccion.TSolicitudMedidaRechazoCollection"
                                         [columns]="colsMedidas" sortField="Id" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm pt-4"
                                         [ngClass]="displayGridHidden(inspeccion.TSolicitudMedidaRechazoCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='Id' && col.field!=='FechaComienzoCuarentena' && col.field!=='FechaTerminacionPrevistaCuarentena' && col.field!=='FechaTerminacionCuarentena')">
                                                    {{rowData[col.field]}}
                                                </span>
                                                <span *ngIf="col.field==='FechaTerminacionPrevistaCuarentena'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>
                                                <span *ngIf="col.field==='FechaTerminacionCuarentena'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>
                                                <span *ngIf="col.field==='FechaComienzoCuarentena'">{{rowData[col.field] | date:'dd/MM/yyyy'}}</span>

                                                <div *ngIf="col.field==='Link'" class="btn-group">

                                                    <div>
                                                        <button [disabled]="!habilitarEdicion" (click)="onDeleteMedidaRechazo(rowData)" type="button" title="Eliminar"
                                                                class="btn btn-sm btn-danger">
                                                            <span class="fa fa-remove"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>

                                <div class="row group-filtros">
                                    <input *ngIf="false" formControlName="validMedidas" [ngClass]="displayFieldCss('validMedidas')" name="" title="" class="form-control" id="inpDescripcion" value="">
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('validMedidas','required')">
                                        Debe introducir al menos una Medida
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- DOCUMENTOS DE LA SOLICITUD -->
                        <div class="row" *ngIf="visibilityDocumentos">
                            <div class="col-md-12">
                                <div class="card card-accent-success animated fadeIn container-filter">
                                    <a class="card-header-a" (click)="isCollapsedDocumentos = !isCollapsedDocumentos" [attr.aria-expanded]="!isCollapsedDocumentos" aria-controls="collapseExample">
                                        <div class="card-header-buscador">
                                            <i class="fa fa-file-text-o"></i><strong> {{tituloDocumentosAdjuntos}}</strong>
                                            <i *ngIf="isCollapsedDocumentos" class="fa fa-caret-down float-right"></i>
                                            <i *ngIf="!isCollapsedDocumentos" class="fa fa-caret-up float-right"></i>
                                        </div>
                                    </a>
                                    <div class="card-body-detalle">
                                        <div class="collapse group-filtros-cf" id="collapsedDocumentos" [ngbCollapse]="isCollapsedDocumentos">

                                            <label class="col-form-label">
                                                <i class="fa fa-align-justify"></i> Listado de documentos
                                            </label>

                                            <p-table #tableSearch autoLayout="true" [value]="documentos"
                                                     [columns]="colsDocumentos" sortField="Fecha" sortOrder="-1"
                                                     styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                                     [ngClass]="displayGridHidden(documentos)"
                                                     (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
                                                     (onHeaderCheckboxToggle)="selectAllRows($event)" [(selection)]='documentosAttachedRechazoBDChecked'>

                                                <ng-template pTemplate="header" let-columns>
                                                    <tr>
                                                        <th>
                                                            <p-tableHeaderCheckbox *ngIf="visibilityTableHeaderCheckbox" [disabled]="!habilitarEdicion">></p-tableHeaderCheckbox>
                                                        </th>
                                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                            {{col.header}}
                                                            <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                                        </th>
                                                    </tr>
                                                </ng-template>
                                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                                    <tr>

                                                        <!--<td *ngIf="visibilityTableHeaderCheckbox">-->
                                                            <p-tableCheckbox [value]="rowData" [disabled]="!habilitarEdicion"> </p-tableCheckbox>
                                                        <!--</td>-->

                                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">

                                                            <span *ngIf="(col.field !== 'Link' && col.field !== 'Fecha')">
                                                                {{rowData[col.field]}}
                                                            </span>
                                                            <span *ngIf="col.field==='Fecha'">
                                                                {{rowData[col.field] | date:'dd/MM/yyyy'}}
                                                            </span>

                                                            <div *ngIf="col.field==='Link'">
                                                                <button (click)="onDownload(rowData)" type="button" title="Descargar Documento" class="btn btn-sm btn-danger">
                                                                    <span class="fa fa-download"></span>
                                                                </button>
                                                                <span *ngIf="col.field==='Link' && isTracesInfoVisible(rowData)">
                                                                    <img class="estado-icono" src="{{ (rowData['ReferenciaTraces'] | IconoDocumentoTraces)[0]}}" container="body" ngbTooltip="{{ (rowData['ReferenciaTraces'] | IconoDocumentoTraces)[1]}}" />
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                </ng-template>
                                            </p-table>
                                            <div *ngIf="numeroDocumentos === 0" class="empty-grid">
                                                No hay documentos asociados a la solicitud
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- FIN DOCUMENTOS PARA EL RECHAZO -->
                    </div>
                </div>

                <!--DESTINO CONTROLADO-->
                <!--<div class="card card-accent-success animated fadeIn">
        <a class="card-header-a">
            <div class="card-header-buscador">
                <i class="fa fa-list"></i> Destino Controlado
            </div>
        </a>
        <div class="card-body-detalle">
            <div class="row">
                <div class="form-group col-md-6">
                    <label class="col-form-label" [ngClass]="{ 'required-field' : destinoControlObligatorio }" for="inpDescripcion">Nombre</label>
                    <div class="input-group">
                        <input readonly formControlName="Descripcion" name="Nombre" title="" class="form-control" [ngClass]="displayFieldCss('Descripcion')" id="" type="text" value="">
                        <span class="input-group-btn">
                            &nbsp;<button name="btnSearchDestinoControl" class="btn btn-list btn-secondary" type="button"
                                          title="Buscar Destino Controlado" (click)="onSearchDestinoControl()">
                                <i class="fa fa-search"></i>
                            </button>
                        </span>
                    </div>

                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Descripcion','required')">
                        El Destino Controlado es obligatorio debido a una de las medidas seleccionadas
                    </div>
                </div>
                <div class="form-group col-md-3">
                    <label class="col-form-label" [ngClass]="{ 'required-field' : destinoControlObligatorio }" for="inpDescripcion">País</label>
                    <input readonly formControlName="IdPaisDescripcion" [ngClass]="displayFieldCss('IdPaisDescripcion')" name="IdPaisDescripcion" title="" class="form-control" id="" type="text" value="">

                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisDescripcion','required')">
        País es obligatorio
    </div>
                </div>
                <div class="form-group col-md-3">
                    <label class="col-form-label" [ngClass]="{ 'required-field' : destinoControlObligatorio }" for="inpDescripcion">Código Traces</label>
                    <input readonly formControlName="IdentificadorTraces" [ngClass]="displayFieldCss('IdentificadorTraces')" name="IdentificadorTraces" title="" class="form-control" id="" type="text" value="">

                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdentificadorTraces','required')">
        Código Traces es obligatorio
    </div>
                </div>

            </div>

            <div class="row">
                <div class="form-group col-md-3">
                    <label class="col-form-label" [ngClass]="{ 'required-field' : destinoControlObligatorio }" for="inpDescripcion">Localidad</label>
                    <input readonly formControlName="Localidad" [ngClass]="displayFieldCss('Localidad')" name="Localidad" title="" class="form-control" id="" type="text" value="">

                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Localidad','required')">
        Localidad es obligatorio
    </div>
                </div>
                <div class="form-group col-md-9">
                    <label class="col-form-label" [ngClass]="{ 'required-field' : destinoControlObligatorio }" for="inpDescripcion">Dirección</label>
                    <input readonly formControlName="Direccion" [ngClass]="displayFieldCss('Direccion')" name="Direccion" title="" class="form-control" id="" type="text" value="">

                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Direccion','required')">
        Dirección es obligatorio
    </div>
                </div>
            </div>
        </div>
    </div>-->


            </div>
    </div>

</form>
